/**
 * Status Pill Component
 * Displays status as colored pill: Optimal (green) or Needs Attention (orange)
 */

import React from 'react';

interface StatusPillProps {
    status: 'optimal' | 'needs_attention' | 'missing';
}

const StatusPill: React.FC<StatusPillProps> = ({ status }) => {
    const getLabel = () => {
        switch (status) {
            case 'optimal':
                return 'Optimal';
            case 'needs_attention':
                return 'Needs Attention';
            case 'missing':
                return 'Missing';
            default:
                return status;
        }
    };

    return (
        <span className={`status-pill ${status}`}>
            {getLabel()}
        </span>
    );
};

export default StatusPill;
